import React from "react";
import { dateString, } from "../calculations/utilsV2";
import { styleByGroup } from "../calculations/calcV2";

interface GraphHeaderProps {
    date: string,
    firm?: string,
    isDaysAgo?: boolean,
    diffs: PartyValue[],
}

export const GraphHeaderV2 = (props: GraphHeaderProps) => {
    const { date, firm, isDaysAgo, diffs } = props;

    const currDate = new Date(date);

    const dateDiff = new Date().getTime() - currDate.getTime();
    const old = Math.floor(dateDiff / (1000*60*60*24));
    const days = !currDate ? undefined : Math.floor(dateDiff / (1000*60*60*24));
    const daysAgo = () => {
        if (days === undefined) { return <span /> }
        else if (days <= 7) {
            return <span className="highlight hlFirst">less than a week ago</span>;
        } else if (days <= 14) {
            return <span className="highlight hlSecond">a week ago</span>;
        } else if (days <= 21) {
            return <span className="highlight hlThird">two weeks ago</span>;
        } else if (days <= 28) {
            return <span className="highlight hlThird">three weeks ago</span>;
        } else if (days <= 60) {
            return <span className="highlight hlFourth">a month old</span>;
        } else {
            return <span className="highlight hlFourth">old</span>;
        }
    }
    const getCurrDate = () => {
        if (!currDate || !old) { return null; }
        if (old <= 7) {
            return <span className="highlight hlFirst">{dateString(currDate)}</span>;
        } else if (old <= 14) {
            return <span className="highlight hlSecond">{dateString(currDate)}</span>;
        } else if (old <= 21) {
            return <span className="highlight hlThird">{dateString(currDate)}</span>;
        } else {
            return <span className="highlight hlFourth">{dateString(currDate)}</span>;
        }
    }

    //const diffs = getPollValues(countryStat, getPollDiff(curr, prev));

    const changes = () => {
        return diffs?.filter(x => x.value !== 0).sort((a, b) => b.value - a.value).map(x => <span key={x.party} className={"tooltip highlight " + styleByGroup(x.group)}>
            <span className="tooltipText">{x.party}</span>
            {x.value > 0 ? '+' : ''}{x.value}
        </span>)
    }

    return <div>
        {getCurrDate()}
        { isDaysAgo && daysAgo()}
        { firm && 
            <span className="highlight groupNi">{firm}</span>
        }
        {changes()}
    </div>
}